import { useState } from 'react'
import { AppliedSortsAndFilters } from './RegistryGiftGiverPage.types'

export const defaultAppliedSortsAndFilters: AppliedSortsAndFilters = {
  filters: {
    category: 'All',
    price: undefined,
    stores: undefined,
  },
  sort: 'category',
}

export const useAppliedSortsAndFilters = () => {
  const [appliedSortsAndFilters, setAppliedSortsAndFilters] =
    useState<AppliedSortsAndFilters>(defaultAppliedSortsAndFilters)

  const handleSortFilterChange = (changes: Partial<AppliedSortsAndFilters>) => {
    setAppliedSortsAndFilters((prev: AppliedSortsAndFilters) => {
      const { filters } = changes
      const { filters: prevFilters, sort: prevSort } = prev

      return {
        filters: {
          category: applyIfPresent(filters, 'category', prevFilters.category),
          price: applyIfPresent(filters, 'price', prevFilters.price),
          stores: applyIfPresent(filters, 'stores', prevFilters.stores),
        },
        sort: applyIfPresent(changes, 'sort', prevSort),
      }
    })
  }

  return { appliedSortsAndFilters, handleSortFilterChange }
}

const applyIfPresent = (
  changes: Record<string, any> | undefined,
  property: string,
  fallback: any
) => {
  if (!changes) return fallback

  return Object.prototype.hasOwnProperty.call(changes, property)
    ? changes[property]
    : fallback
}
